import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useReceiptStore = defineStore('receiptStore', () => {
  const receiptData = ref({})
  const loading = ref(false)
  return {
    receiptData,
    loading
  }
})
